export const ARROW_KEY_UP = 38;
export const ARROW_KEY_DOWN = 40;
export const ARROW_KEY_RIGH = 39;
export const ARROW_KEY_LEFT = 37;

export const VNS_ORDER_MANAGEMENT_LOCATION = 'vns_order_mng_location';
export const LOCALSTORAGE_CART_APPLY_COUPON = 'CART_APPLY_COUPON';
export const LOCALSTORAGE_CART_OPEN_COUPON_SELECTOR =
  'CART_OPEN_COUPON_SELECTOR';

export const userSelectedConstants = {
  TERMINAL: 'terminal',
  TERMINAL_ID: 'terminal_id',
  LOCATION: 'location_code',
};

export const LOCALSTORAGE_SELECTED_PAYMENT_METHOD = 'selected-payment-method';
